
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcCommandMenu as ObcCommandMenuElement} from '@oicl/openbridge-webcomponents/dist/components/command-menu/command-menu.js';
 
 
 

 
 export const ObcCommandMenu = createComponent({
   react: React,
   tagName: 'obc-command-menu',
   elementClass: ObcCommandMenuElement,
   events: {
     
     onChange: 'change' as EventName<CustomEvent<{inCommand: boolean}>>,
   }
  });
 
 